import {Presenter} from '../../../Support/with_presenter';
import {PartialWorkout} from '../../../Models/PartialWorkout';
import {WorkoutsService} from '../../../Network/WorkoutsService';
import {WorkoutListViewModel} from '../../Components/Workout/WorkoutList';

export class CrewsWorkoutsTablePresenter implements Presenter {

    private _partialWorkouts: PartialWorkout[] = [];

    public partialWorkoutCount: number;

    public constructor(
        _partialWorkouts: PartialWorkout[],
        private workoutsService: WorkoutsService,
    ) {
        this._partialWorkouts = _partialWorkouts;
        this.partialWorkoutCount = this._partialWorkouts.length;
    }

    public get workoutListViewModels(): WorkoutListViewModel[] {
        const partialWorkoutsOnPage = this._partialWorkouts;

        return partialWorkoutsOnPage.map((partialWorkout) => {
            return WorkoutListViewModel.fromPartialWorkout(partialWorkout);
        });
    }

    public mount(): void {
        /* Noop */
    }

    public unmount(): void {
        /* Noop */
    }

}
